export default __webpack_public_path__ + "static/media/gap_icon.4e73eaf8.svg";